import { RestartAlt, Search } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC } from "react";
import RegisterFab from "./RegisterFab";

type FilterButtonsProps = {
  isLoading: boolean,
  isDisabled?: boolean,
  search: () => void,
  resetState: () => void,
  registerUrl?: string;
}

const FilterButtons: FC<FilterButtonsProps> = ({
  isLoading,
  isDisabled = false,
  search,
  resetState,
  registerUrl,
}): JSX.Element => {
  return (
    <>
      <Button
        variant="contained"
        startIcon={<Search />}
        onClick={() => {
          search()
        }}
        disabled={isLoading || isDisabled}
        sx={{
          maxHeight: '100%',
          height: '56px',
        }}
      >
        {isLoading ? "Buscando..." : "Buscar"}
      </Button>
      <Button
        variant="contained"
        startIcon={<RestartAlt />}
        onClick={() => {
          resetState();
        }}
        disabled={isLoading || isDisabled}
        sx={{
          maxHeight: '100%',
          height: '56px',
        }}
      >
        Limpar
      </Button>

      {registerUrl && (
        <RegisterFab registerUrl={registerUrl!} />
      )}
    </>
  )
}

export default FilterButtons;
